"use strict";

class PropertyViewController {

    constructor( $parse, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSConfigService, SSAppService, SSAlertService, OTPService, NgTableParams,SSConfirmationService, SSUserService, Upload, SSAnalyticsService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;
        self.$window = $window;
        self.$localStorage = $localStorage;

        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.NgTableParams = NgTableParams;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.data = SHOWSUITE.data;


        //Document Kinds
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION= SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;

        // Property Status
        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT; // Just Created
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW; // Submitted for Review
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED; // Rejected by the Showsuite Admin
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED; // Listed on portal and publicly visible
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED; // Not Listed on portal and publicly visible


        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC_CORE = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_TEAM_IC_CORE;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_AGENTS = SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_AGENTS;
        self.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_NONE =SHOWSUITE.PROPERTY_SETTINGS_DOCUMENT_DOWNLOAD_AVAILABILITY_NONE;


        self.AVAILABILITY_PUBLIC = SHOWSUITE.AVAILABILITY_PUBLIC;
        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.AVAILABILITY_BROKERS_TEAM = SHOWSUITE.AVAILABILITY_BROKERS_TEAM;
        self.AVAILABILITY_TEAM_LEADS = SHOWSUITE.AVAILABILITY_TEAM_LEADS;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;
        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD;

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_CREDIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_CREDIT_CARD;
        self.INSTRUMENT_TYPE_CASH = SHOWSUITE.INSTRUMENT_TYPE_CASH;

        self.PROPERTY_STATUS_DEV_CHANGE_MAP = {};
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_DRAFT] = self.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_REJECTED] = self.PROPERTY_STATUS_REVIEW;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_APPROVED] = self.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_LISTED] = self.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.PROPERTY_STATUS_ARCHIVED] = self.PROPERTY_STATUS_ARCHIVED;

        self.PROPERTY_STATUS_CHANGE_MAP_TEXT = {};
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_DRAFT] = 'Submit For Review';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_REJECTED] = 'Re-Submit For Review';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_APPROVED] = 'Publish';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_LISTED] = 'Un-Publish';
        self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.PROPERTY_STATUS_ARCHIVED] = 'Archived';
        // Property Status

        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;
        self.PAYMENT_PLAN_TYPE_ALL = SHOWSUITE.PAYMENT_PLAN_TYPE_ALL;

        self.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION = SHOWSUITE.PROPERTY_SETTINGS_LONGER_UNIT_RESERVATION_NOTIFICATION;        

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;

        self.payment_types = [
            { id: self.INSTRUMENT_TYPE_CHEQUE, name: "Bank Cheque", allowed: false },
            { id: self.INSTRUMENT_TYPE_CASHIERS_ORDER, name: "Cashier's Order", allowed: false },
            { id: self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER, name: "Telegraphic Transfer (TT)", allowed: false },
            { id: self.INSTRUMENT_TYPE_CASH_IN, name: "Cash-In", allowed: false },
            { id: self.INSTRUMENT_TYPE_GIRO, name: "GIRO", allowed: false },
            { id: self.INSTRUMENT_TYPE_DEBIT_CARD, name: "Debit Card", allowed: false },
            { id: self.INSTRUMENT_TYPE_FAST_CASH, name: "Fast Cash", allowed: false },
            { id: self.INSTRUMENT_TYPE_BANK_TRANSFER, name: "Bank Transfer", allowed: false },
            { id: self.INSTRUMENT_TYPE_PAYNOW_OTHERS, name: "PayNow Others", allowed: false },
            { id: self.INSTRUMENT_TYPE_CREDIT_CARD, name: "Credit Card", allowed: false },
            { id: self.INSTRUMENT_TYPE_CASH, name: "Cash", allowed: false },
        ];

        self.archive_project = null;
        self.archive_project_val = null;

        self.user = self.SSUserService.getUser();
        self.law_firms = self.SSConfigService.getLawFirms();
        self.law_firms.push({'code': '999999', 'name': 'OTHERS'});

        self.unitStatusesFilter = [];
        self.SSConfigService.serverConfig.unit_statuses.forEach(status => {
            self.unitStatusesFilter.push(status);
        })

        if (self.SSUserService.isDeveloper() && self.data.property) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Property Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_PROPERTY,
                user_id: self.SSUtilService.getFromLocalStorage('user').id,
                property_id: self.data.property.id
            }
        );

        self.pricePlanSelected = "";
        //self.psettings.default_allowed_document_kinds = {};
        //self.showDocumentKindsList = false;

        // If user has permission to view discounts then call API
        if(self.SSUserService.hasPermissionForProperty('DMS_PROJ_VIEW_DIST', self.data.property.id)){
            console.log('Permission denied: DMS_PROJ_VIEW_DIST');
            self.getDiscounts();
        }
        else{
            self.getProperty();
        }

        //set property and user id's in local Storage
        self.$localStorage["user_property"] = {
            'user_id' : self.$localStorage['user'].id,
            'property_id': self.data.property_id
        };

        //self.maskPhoneNumber(self, 'ctrl.', 'lawyerdetails');
        self.offset = 0;
        self.limit = '100';
        self.current = 1;
        self.today = moment().format('YYYY-MM-DD HH:mm:ss');
        self.selected_units_count = 0;
        self.jump_to_page = 1;

        self.pageChanged = function(newPage) {
            self.loadUnits(newPage);
            if(self.tempObj)
            {
                self.applySearch();
            }
        };

        self.setPageOptions();
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    hasPermission(permission, property_id){
        const self = this;

        if(permission && self.SSUserService.hasPermissionForProperty(permission, property_id)){
            self.permission_code = permission;
            return true;
        }
        
        // Check permission for live projects
        if(self.data.property.status == self.PROPERTY_STATUS_LISTED){
            self.permission_code = 'DMS_PROJ_VW_LIVE_D';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_LIVE_D', property_id);
        }
        // Check permission for draft projects
        else if(self.data.property.status == self.PROPERTY_STATUS_DRAFT
            || self.data.property.status == self.PROPERTY_STATUS_REVIEW
            || self.data.property.status == self.PROPERTY_STATUS_APPROVED
            || self.data.property.status == self.PROPERTY_STATUS_REJECTED){
            self.permission_code = 'DMS_PROJ_VW_DRAFT_D';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_DRAFT_D', property_id);
        }
        // Check permission for archived projects
        else if(self.data.property.status == self.PROPERTY_STATUS_ARCHIVED){
            self.permission_code = 'DMS_PROJ_VW_ARCHIVE';
            return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_ARCHIVE', property_id);
        }
        else{
            self.permission_code = 'Unknown Code. Please contact admin';
            return false;
        }
    }

    loadUnits(page, units){
        const self = this;

        // if(self.unit_status && !filtered){
        //     self.filterUnitsByStatus(self.unit_status);
        // }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!units){
            units = self.setUpUnitPrices(self.pricelist.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
        }

        self.units_master = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;


        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.units_master.length)){
            self.selected_units_count = self.limit;
        }
        else{
            self.selected_units_count = self.units_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }
    // Property --------------------------------------------------------------------------------------------------------
    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        let url = 'sec/developer/properties/' + self.data.property_id + '?include=units_data2';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.unitsData = response.data.units_data2;
            self.stats = response.data.stats;
            self.typeMaps = response.data.type_map;
            self.unitTypes = response.data.unit_types;
            self.next_otp_no = response.data.next_otp_no;
            self.next_sub_sale_tracking_no = response.data.next_sub_sale_tracking_no;

            let balanceUnits=self.SSAppService.getRemainingUnits(self.property);
            self.sold_units=self.SSAppService.getLaunchedUnits(self.property)-balanceUnits;
            self.propertyPieChart=[{0:
                [{label:"Available Units", value : balanceUnits},
                {label:"Sold Units", value :self.sold_units,}]
            }];
            self.getUnitSchedules();
            self.getUnitData();
        });
    }


    getDiscounts() {
        const self = this;

        if (!self.data.property)
            return;

        // If user has permission to view discounts then call API
        if(!self.SSUserService.hasPermissionForProperty('DMS_PROJ_VIEW_DIST', self.data.property.id)){
            return;
        }

        self.property = null;
        let url = 'sec/developer/properties/' + self.data.property_id + '/discounts';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property_discounts = response.data.property_discounts;

            self.getProperty();
        });
    }

    getPropertyThumbUrl() {
        const self = this;

        let url = '';

        if (self.property) {
            url = self.SSAppService.getPropertyHeroThumbUrl(self.property);
        }

        return url;
    }

    exportPriceList(id){
        const self = this;
        let url = "sec/developer/properties/"+id+"/price-list-export";

        if (self.pricePlanSelected) {
            url += "?unit_price_schedule_id=" + self.pricePlanSelected;
        }

        /** WEB-2898 DMS : Price List and Price Plans UI improvements
         * Need to send param timezone with local timezone offset **/
        let todayDate = new Date();
        let timezoneOffset = todayDate.getTimezoneOffset();
        timezoneOffset *= -1; // Get the offset from Local time
        let timezoneOffsetParam = (timezoneOffset >= 0 ? '+' : '-') + Math.abs(timezoneOffset);
        url+= (url.indexOf("?") > -1)? "&" : "?";
        url+="timezone_offset_minutes=" + timezoneOffsetParam;

        url = self.SSHttpService.getApiURL(url);
        self.$window.open(url, '_blank');
    }

    updateFilter() {
        const self = this;

        self.offset = 0;
    }

    getUnitNumber(unit) {
        const self = this;

        if (unit) {
            return self.SSUtilService.getFullUnitNumber1(unit, false);
        } else {
            return '-';
        }
    }

    applySearch(){
        const self = this;

        var units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        self.loadUnits(undefined, units);
    }

    isSearchApplied(){
        const self = this;

        if(!self.tempObj.floor && !self.tempObj.unit && !self.tempObj.type_desc && !self.tempObj.floor_plan && !self.tempObj.size_ft2
            && !self.tempObj.psf && !self.tempObj.price && !self.tempObj.discounted_price
            && !self.tempObj.total_discounted_psf && !self.tempObj.total_discount_price && !self.tempObj.updated_at
            && !self.tempObj.status && !self.tempObj.reserve_price_search){

            return false;
        }
        else{
            return true;
        }
    }

    getFilteredUnits(){
        const self = this;

        let units = [];

        let is_match = true;
        units = self.unitsBackup.filter(unit => {
            is_match = true;

            if (self.tempObj.floor && !self.isStringMatch(unit.floor_no, self.tempObj.floor)) {
                is_match = false;
            }
            if (self.tempObj.unit &&!self.isStringMatch(unit.unit_no, self.tempObj.unit)) {
                is_match = false;
            }
            if (self.tempObj.type_desc && !self.isStringMatch(unit.type_desc, self.tempObj.type_desc)) {
                is_match = false;
            }
            if (self.tempObj.size_ft2 && !self.isStringMatch(unit.size_ft2, self.tempObj.size_ft2)) {
                is_match = false;
            }
            if (self.tempObj.floor_plan && !self.isStringMatch(unit.floor_plan, self.tempObj.floor_plan)) {
                is_match = false;
            }
            if (self.tempObj.psf && !self.isStringMatch(unit.psf, self.tempObj.psf)) {
                is_match = false;
            }
            if (self.tempObj.price && !self.isStringMatch(unit.price, self.tempObj.price)) {
                is_match = false;
            }
            if (self.tempObj.updated_at && !self.isStringMatch(unit.discounted_price_updated_at, self.tempObj.updated_at)) {
                is_match = false;
            }
            if (self.tempObj.total_discounted_psf && !self.isStringMatch(unit.total_discounted_psf, self.tempObj.total_discounted_psf)) {
                is_match = false;
            }
            if (self.tempObj.total_discount_price && !self.isStringMatch(unit.total_discount_price, self.tempObj.total_discount_price)) {
                is_match = false;
            }
            if (self.tempObj.reserve_price_search && !self.isStringMatch(unit.reserve_price, self.tempObj.reserve_price_search)) {
                is_match = false;
            }
            if (self.tempObj.status && (!unit.status || unit.status !== self.tempObj.status)) {
                is_match = false;
            }
            if (self.tempObj.discounted_price && !unit.discounted_price.find(discount => {
                return self.isStringMatch(discount.amount_value, self.tempObj.discounted_price);
            })){
                is_match = false;
            }

            return is_match;
        })

        return units;
    }

    isStringMatch(val1, val2) {
        if (!val1 || !val2) { return false; }

        try {
            return val1.toString().trim().toLowerCase().includes(val2.trim().toLowerCase());
        } catch(e) {
            console.error(e);
            return false;
        }
    }

    zeroPad(n,length){
        var s=n+"",needed=length-s.length;
        if (needed>0) s=(Math.pow(10,needed)+"").slice(1)+s;
        return s;
    }

    getLawyerDetails() {
        const self = this;
        if (!self.data.property_id)
            return;


        self.lawyerdetail = null;


        let url = 'sec/developer/properties/'+ self.data.property_id +'/lawyers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.lawyerdetail=self.SSHttpService.parseErrors(response);

            self.lawyerdetail = response.data;


            if(!self.lawyerdetail.lawyers)
            {
                self.editorEnabled = !self.editorEnabled;
                self.lawyerdetail["lawyers"] = {};
            } else {
                //Check if law firm stored is others
                if (!self.law_firms.find(x => x.name === self.lawyerdetail.lawyers.law_firm_name)) {
                    self.lawyerdetail.lawyers.law_firm_name_other = angular.copy(self.lawyerdetail.lawyers.law_firm_name);
                    self.lawyerdetail.lawyers.law_firm_name = "OTHERS";
                }
            }

            self.maskPhoneNumber(self, 'ctrl.');

            self.$timeout(function() { 
                $("select.dashboard-select").niceSelect('update'); 
            });
        });
    }

    //get the pricelist

    getPriceList() {
        const self = this;
        if (!self.property.id)
            return;

        self.pricelist = null;
        self.select_option= null;
        self.updated_at = null;

        self.standard_discounts = [];

        let params = {
            'limit': 2000,
            'offset': 0,
            'send_total_count': true
        };



        let url = 'sec/developer/properties/'+ self.property.id +'/units';

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.pricelist = response.data;
            self.select_option = ["unit_no", "type_desc", "floor_plan", "size_ft2","psf","price","updated_at"];

            jQuery.each(self.property_discounts, function(i, discount){
                if(discount.type == self.DISCOUNT_TYPE_STANDARD
                        && discount.is_active == 1
                        && !discount.marketing_scheme
                        && ((moment(discount.availability_start_date, "YYYY-MM-DD HH:mm:ss") <= moment(self.today, "YYYY-MM-DD HH:mm:ss"))
                        && (moment(discount.availability_end_date, "YYYY-MM-DD HH:mm:ss") >= moment(self.today, "YYYY-MM-DD HH:mm:ss")))){

                    if(!self.updated_at){
                        self.updated_at = discount.updated_at;
                    } else{
                        if(moment(discount.updated_at, "YYYY-MM-DD HH:mm:ss") > moment(self.updated_at, "YYYY-MM-DD HH:mm:ss")){
                            self.updated_at = discount.updated_at;
                        }
                    }
                    self.standard_discounts.push(discount);
                }
            });

            self.pricelist.property_units = self.setUpUnitPrices(self.pricelist.property_units);

            let units = angular.copy(self.pricelist.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');

            self.units_master = angular.copy(units);
            self.unitsBackup = angular.copy(units);
            self.units_backup_default_price_list = angular.copy(units);
            self.count = self.units_master.length;
            self.loadUnits(undefined, self.units_master);
            self.getLawyerDetails();

        });
    }
    // Property --------------------------------------------------------------------------------------------------------
    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        let parent = jQuery;
        if (formId) {
            parent = jQuery('#' + formId);
        }


        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {

                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }
    // Property Status -------------------------------------------------------------------------------------------------
    getPropertyStatusChangeText() {
        let self = this;

        let status = null;

        if (self.property) {
            status = self.PROPERTY_STATUS_CHANGE_MAP_TEXT[self.property.status];
        }

        return status;
    }

    updatePropertyStatus() {
        const self = this;

        self.OTPService.getVerified(function (data) {
                self._updatePropertyStatus(data);
            },
            self.OTPService.TYPE_SESSION_2FA
        );
    }

    _updatePropertyStatus() {
        let self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/update-status';
        let params = {
            status: (self.archive_project_val) ? self.archive_project_val : self.PROPERTY_STATUS_DEV_CHANGE_MAP[self.property.status],
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Project status updated successfully.");

            self.property.status = params.status;
        });
    }

    toggleArchiveProject() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + (self.archive_project ? '"Archive"' : '"Unarchive"') + ' project?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {
                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function () {
                        self.archive_project_val = (self.archive_project) ? self.PROPERTY_STATUS_ARCHIVED : self.PROPERTY_STATUS_DRAFT;
                        self._updatePropertyStatus();
                    }
                );
            }
        );
    }
    // Property Status -------------------------------------------------------------------------------------------------

    // Price Visibility ------------------------------------------------------------------------------------------------
    togglePriceVisibility() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + (self.property.price_visibility ? '"HIDE"' : '"SHOW"') + ' prices?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (data) {
                        self._togglePriceVisibility(data);
                    }
                );
            }
        );
    }

    _togglePriceVisibility() {
        let self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/update-price-visibility';
        let params = {
            price_visibility: self.property.price_visibility ? 0 : 1,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Project price visibility updated successfully.");

            self.property.price_visibility = params.price_visibility;
        });
    }
    // Price Visibility ------------------------------------------------------------------------------------------------

    // Util Functions --------------------------------------------------------------------------------------------------
    toDecimal(a, b) {
        return Math.round(a / 100 * b * 100) / 100;
    }

    toPercentage(a, b) {
        return Math.round(a / b * 100 * 100) / 100;
    }

    getRoundValue(param1, param2) {
        param1.toFixed(2);
    }

    daysPassed(date) {
        const self = this;

        date = self.SSUtilService.parseDate(date);
        if (!date) return 0;

        var diffInMilliseconds = Date.now() - date.getTime();
        var millisecondsInOneDay = 1000 * 60 * 60 * 24; //Get 1 day in milliseconds

        let days = Math.round(diffInMilliseconds / millisecondsInOneDay);

        return days > 0 ? days : 0;
    }

    // Util Functions --------------------------------------------------------------------------------------------------


    getRoundValue(param1, param2) {
        param1.toFixed(2);
    }

    daysPassed(date) {
        const self = this;

        date = self.SSUtilService.parseDate(date);
        if (!date) return 0;

        var diffInMilliseconds = Date.now() - date.getTime();
        var millisecondsInOneDay = 1000 * 60 * 60 * 24; //Get 1 day in milliseconds

        let days = Math.round(diffInMilliseconds / millisecondsInOneDay);

        return days > 0 ? days : 0;
    }
    // Util Functions --------------------------------------------------------------------------------------------

    // Will be used later ----------------------------------------------------------------------------------------------
    saveAgencyCommission() {
        let thisCtrl = this;

        let params = {
            "property_id": thisCtrl.property.id,
            "agencyId": thisCtrl.agencySelected,
            "commission": thisCtrl.currentAgencyCommission,

        };

        if (Number.isInteger(Number(thisCtrl.currentAgencyCommission))) {
            thisCtrl.SSHttpService.postRequest(`developer/agencies/setAgencyCommission`, params).then(function (responseObj) {
                thisCtrl.progressUploadingFiles = false;
                if (responseObj instanceof Error) {
                    thisCtrl.SSUtilService.logError("Some errrororoororororor ");
                    return;
                }
                thisCtrl.$window.location.reload();
                thisCtrl.currentAgencyCommission = null;
                //$route.reload();
            });
        }
        else {
            if (confirm("wrong input!!!") == true) {
                thisCtrl.$window.location.reload();
            } else {
                thisCtrl.$window.location.reload();
            }
        }
    }

    populateAvailableAgencies() {
        var res = [];
        var assign = true;
        let self = this;
        if (_.has(this.agencyResponse, 'agencies')) {
            let agencies = this.agencyResponse.agencies;
            if (agencies.length <= 0) {
                $("#agency-div").css({"display": "none"});
            }
            _.forEach(agencies, function (agency) {
                console.log(agency);
                if (assign) {
                    assign = false;
                    self.agencySelected = agency.id;
                }
                res.push({
                    id: agency.id,
                    name: agency.name
                });
            });

            this.availableAgencies = res;
            self.selectAgency();

        }
        else {
            $("#agency-div").css({"display": "none"});
        }
    }

    calculateCommissions(project) {
        let self = this;

        self.commissions = {};
        self.commissions.totalCommission = project.agency_commission;
        self.commissions.broker = self.toDecimal(project.broker_commission, project.agency_commission);
        self.commissions.teamlead = self.toDecimal(project.teamlead_commission, project.agency_commission);
        self.commissions.cobroker = self.toDecimal(project.cobroker_commission, self.commissions.broker);
        self.commissions.agency = Math.round((project.agency_commission - (self.commissions.broker + self.commissions.teamlead + self.commissions.cobroker)) * 100) / 100;
        self.currentAgencyCommission = self.commissions.totalCommission;
    }

    selectAgency() {
        let self = this;
        
        self.leadBroker1 = null;
        self.leadBroker2 = null;
        self.agencyName = "";
        self.agencyContact = "";
        if (this.agencySelected) {
            if (_.has(this.agencyResponse, 'details')) {
                let details = this.agencyResponse.details;
                let agencyDetail = details[this.agencySelected];
                console.log("agencyDetails");
                console.log(agencyDetail);

                self.totalCommission = agencyDetail.agency_total_commission;
                self.agencyCommission = agencyDetail.agency_commission;
                self.agentCommission = agencyDetail.broker_commission;
                self.teamCommission = agencyDetail.team_lead_commission;
                self.cobrokerCommission = agencyDetail.cobroker_commission;
                self.agencyAsset = agencyDetail.agencyAssets;
                self.currentAgencyCommission = self.agencyCommission;
                self.calculateCommissions(agencyDetail.agencyProject);
                console.log("totalCommission");
                console.log(self.totalCommission);
                if (_.has(agencyDetail, 'lead_brokers')) {
                    if (agencyDetail.lead_brokers.length > 0) {
                        console.log("LEAD BRoKER");
                        this.leadBroker1 = agencyDetail.lead_brokers[0];
                        console.log(self.leadBroker1);
                    }
                    if (agencyDetail.lead_brokers.length > 1) {
                        self.leadBroker2 = agencyDetail.lead_brokers[1];
                    }
                }
                self.agencyName = agencyDetail.agency_name;
                self.agencyContact = agencyDetail.agency_contact;

                // $("#agency-div").css({"display": "inline"});

                self.loadUnits();
            }
        }

    }

    getUnitCommission(unitId) {
        console.log("getUnitCommission1 ");
        console.log(unitId);

        let self = this;
        if (this.agencySelected) {
            console.log("Unit commission");
            let agenciesCommisssions = this.unitCommission;
            _.forEach(agenciesCommisssions, function (agency) {
                console.log(self);
                console.log(self.agencySelected);
                console.log("getUnitCommission2");
                console.log(agency);
                if (agency.agency_id == self.agencySelected && agency.unit_id == unitId) {
                    return agency.agency_commission;
                }
            });
        }
        if (this.agencyCommission) {
            return this.agencyCommission;
        }

        return "NA";

    }

    saveUnitCommission() {
        let thisCtrl = this;


        if (Number.isInteger(Number(thisCtrl.currentUnitCommission))) {


            let params = {
                "unit_id": thisCtrl.currentUnitId,
                "agencyId": thisCtrl.agencySelected,
                "commission": thisCtrl.currentUnitCommission,

            };
            console.log("saveUnitCommission");
            console.log(params);

            thisCtrl.SSHttpService.postRequest(`developer/agencies/setUnitCommission`, params).then(function (responseObj) {
                thisCtrl.progressUploadingFiles = false;
                if (responseObj instanceof Error) {
                    thisCtrl.SSUtilService.logError("Some errrororoororororor ");
                    return;
                }
                console.log("Success here close the box");
                // thisCtrl.closePopup();
                thisCtrl.$window.location.reload();
                thisCtrl.currentUnitId = null;
                thisCtrl.currentUnitCommission = null;
                //$route.reload();
            });
        } else {
            if (confirm("wrong input!!!") == true) {
                thisCtrl.$window.location.reload();
            } else {
                thisCtrl.$window.location.reload();
            }

        }
    }

    getAgencyThumbUrl() {
        if (this.agencyAsset.length > 0) {
            return this.SSUtilService.makeAssetUrl(this.agencyAsset[this.agencyAsset.length - 1].file_uri);
        }
    }

    getUnitSchedules() {
        const self = this;

        if(!self.SSUserService.hasPermissionForProperty('DMS_PROJ_VW_PRICE_SH', self.data.property.id)){
            console.log('Permission denied: DMS_PROJ_VW_PRICE_SH');
            return;
        }

        let url = 'sec/developer/properties/' + self.property.id + '/unit-price-schedules?include=unit_price_schedule_details';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                self.unitSchedules = response.data.unit_price_schedules;
                self.getPriceList();
            }
        });
    }

    changePricePlan() {
        const self = this;

        if (self.pricePlanSelected) {
            //Update units_master with price schedule price
            let price_plan = self.unitSchedules.find(x => x.id == self.pricePlanSelected);

            let new_units_list = [];

            $.each(self.unitsBackup, function(index, unit) {
                let new_unit = angular.copy(unit);
                let schedule_unit = price_plan.unit_price_schedule_details.find(x => x.unit_id == new_unit.id);

                if (schedule_unit) {
                    new_unit.price = schedule_unit.price;
                    new_unit.reserve_price = schedule_unit.reserve_price;
                }

                new_units_list.push(new_unit);
            });

            new_units_list = self.setUpUnitPrices(new_units_list);
            self.units_master = angular.copy(new_units_list);
            self.unitsBackup = angular.copy(new_units_list);
        } else {
            //Back to normal
            self.units_backup_default_price_list = self.setUpUnitPrices(self.units_backup_default_price_list);
            self.units_master = angular.copy(self.units_backup_default_price_list);
            self.unitsBackup = angular.copy(self.units_backup_default_price_list);
        }
    }

    setUpUnitPrices(units) {
        const self = this;

        $.each(units, function(i, unit){
            var updated_at = unit.updated_at || null;

            /** WEB-2898 DMS : Price List and Price Plans UI improvements
             * If price plan selected then set price plan updated date as Date Updated **/
            if(self.pricePlanSelected){
                $.each(self.unitSchedules, function(i, unitSchedule){
                    if(unitSchedule.id === self.pricePlanSelected){
                        if(unitSchedule.unit_price_schedule_details
                                && unitSchedule.unit_price_schedule_details.length){
                            let unit_price_schedule_detail = unitSchedule.unit_price_schedule_details
                                    .find(ps =>ps.unit_id === unit.id);

                            if(unit_price_schedule_detail){
                                updated_at = unit_price_schedule_detail.updated_at || updated_at;
                            }
                        }
                    }
                })
            }

            unit.discounted_price = [];
            $.each(self.standard_discounts, function(index_discount, discount){
                if(discount.unit_ids){
                    if (discount.unit_ids.indexOf(unit.id) !== -1) {
                        if(!updated_at){
                            updated_at = discount.updated_at;
                        } else if(moment(discount.updated_at, "YYYY-MM-DD HH:mm:ss") > moment(updated_at, "YYYY-MM-DD HH:mm:ss")){
                            updated_at = discount.updated_at;
                        }

                        if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
                            var disounted_price_amount = discount.amount_value;
                            unit.discounted_price.push({
                                'discount_amount': disounted_price_amount,
                                'amount_type': discount.amount_type,
                                'amount_value': discount.amount_value,
                                'name': discount.name
                            });
                        } else if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
                            var disounted_price_percentage = ((unit.price * discount.amount_value) / 100);
                            unit.discounted_price.push({
                                'discount_amount': disounted_price_percentage,
                                'amount_type': discount.amount_type,
                                'amount_value': discount.amount_value,
                                'name': discount.name
                            });
                        }
                    }
                }
            });
            var discount_price_value = 0;
            $.each(unit.discounted_price, function(i, discount){
                discount_price_value = discount_price_value + discount.discount_amount;
            });

            unit.psf = Math.round(unit.price / unit.size_ft2);
            unit.total_discount_price = Math.round(unit.price - discount_price_value);
            unit.total_discounted_psf = Math.round(unit.total_discount_price / unit.size_ft2);
            unit.discounted_price_updated_at = self.SSUtilService.formatLocalDateTime(updated_at);
            unit.status_name = self.SSAppService.getUnitStatusName(unit.status);
        });

        return units;
    }

    getUnitData() {
        const self = this;

        self.commercialSoldUnits = 0;
        self.commercialUnSoldUnits = 0;
        self.residentialSoldUnits = 0;
        self.residentialUnSoldUnits = 0;
        self.totalresidentialUnits = 0;
        self.totalcommercialUnits = 0;

        self.TOTAL_PROPERTY_UNITS = 0;

        jQuery.each(self.unitsData, function (key, value) {

            self.TOTAL_PROPERTY_UNITS += value.count; // Total Project Units

            if (value.status == self.UNIT_STATUS_DRAFT) {
                return; // Skip and continue.
                // DRAFT units are not counted under Launched Units, so will not be counted for Sold/Unsold
            }

            if (value.category == 7) {
                if (value.status == self.UNIT_STATUS_SOLD) {
                    self.commercialSoldUnits += value.count;
                } else {
                    self.commercialUnSoldUnits += value.count;
                }
            } else {
                if (value.status == self.UNIT_STATUS_SOLD) {
                    self.residentialSoldUnits += value.count;
                } else {
                    self.residentialUnSoldUnits += value.count;
                }
            }
        });

        self.totalresidentialUnits = self.residentialSoldUnits + self.residentialUnSoldUnits;
        self.totalcommercialUnits = self.commercialSoldUnits + self.commercialUnSoldUnits;
    }

}

PropertyViewController.$inject = [ '$parse', '$window', '$timeout','$localStorage', 'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSAlertService', 'OTPService', 'NgTableParams', 'SSConfirmationService', 'SSUserService', 'Upload', 'SSAnalyticsService'];
app.controller('PropertyViewController', PropertyViewController);

